import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SceneService } from '@services/cms/scene.service';
import { Scene } from '@models/scene';

@Component({
  selector: 'app-form-scene',
  templateUrl: './form-scene.component.html',
  styleUrls: ['./form-scene.component.scss']
})
export class FormSceneComponent implements OnInit {
  public subtitle = 'admin.components.scene.createEditSubtitle';
  private create: boolean;

  constructor(
      public dialogRef: MatDialogRef<FormSceneComponent>,
      public service: SceneService,
      @Inject(MAT_DIALOG_DATA) public data: Scene
  ) {
    this.service.modelClass.model = data;
    this.create = this.service.modelClass.model.escenaID === 0;
    if (this.service.modelClass.model['liveID'] > 0) {
      this.service.modelClass.formCells.filter(x => x.name === 'liveID')[0].disable = true;
    }
  }

  ngOnInit(): void {
  }

  sendForm(): void {
    const self = this;
    if (this.create) {
      self.service.create().then((response) => {
        if (response) {
          self.close(true);
        }else{
          // console.log(response);
        }
      });
    } else {
      self.service.update(self.service.modelClass.model[self.service.modelClass.idName]).then((response) => {
        if (response) {
          self.close(true);
        }
      });
    }
  }

  public close = (reload: boolean = false) => {
    this.dialogRef.close({ data: { reload }});
  }
}
